/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useContext, useRef, useCallback} from "react";
import { purchaseService } from "../../services/purchase.service";
import { Dropdown } from "react-bootstrap";
import LogicContext from "../../Context/LogicContext";
import {GetVendorListData, SetVendorListData} from '../../store/vendorAtom';
// import CurrencyFormat from 'react-currency-format';
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { useState } from "react";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { useLocation, useNavigate } from "react-router-dom";
import ActionPaneComponent from "../../helpers/ActionPaneComponent";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import StatusBadge from "../../generals/StatusBadge";



const columns = [
  {
    title: 'Id',
    key: 'Vendor_Id',
    dataIndex: 'Vendor_Id',
    sorter: (a, b) => (a?.Vendor_Id ?? '') - (b?.Vendor_Id ?? ''),

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Full Name',
    key: 'Vendor_Full_Name',
    dataIndex: 'Vendor_Full_Name',
    className: 'text-primary',
    sorter: (a, b) => (a?.Vendor_Full_Name ?? '').localeCompare(b?.Vendor_Full_Name ?? ''),
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Email',
    key: 'Vendor_Email_Address',
    dataIndex: 'Vendor_Email_Address',
    sorter: (a, b) => (a?.Vendor_Email_Address ?? '').localeCompare(b?.Vendor_Email_Address ?? ''),
    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },
  {
    title: 'Mobile',
    dataIndex: 'Vendor_Mobile_No',
    className: 'text-Vendor_Mobile_No',
    sorter: (a, b) => (a?.Vendor_Mobile_No ?? '').localeCompare(b?.Vendor_Mobile_No ?? ''),

    //   render: () => <HolderOutlined style={{ fontSize: '20px', color:'blue' }} />,
  },

  {
    title: 'Status',
    dataIndex: 'Vendor_Status_Name',
    sorter: (a, b) => (a?.Vendor_Status_Name ?? '').localeCompare(b?.Vendor_Status_Name ?? ''),
    render: (record, row) => (
      <StatusBadge statusId={row?.Vendor_Status_Id} statusName={record} />
    ),
  },
];


function VendorPage() {
  const { pathname } = useLocation();  
  const navigate = useNavigate();
  var url = pathname.split('/')
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const setVendorListData =  SetVendorListData();
  const getVendorListData =  GetVendorListData();
  const myPromiseModal = createModal(GeneralModal);
    const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState([]);
  const [itemSelected, setItemSelected] = useState([]);
  const mountRef = useRef(false);


  useEffect(()=> {
    document.title = 'Vendor';
    if(getVendorListData['Vendor_Info']?.length > 0){
      setTableData(getVendorListData['Vendor_Info']);
    }else{
      getVendorListFromApi();
    }
   
  },[getVendorListData ]);



    useEffect(() => {
      if (sessionStorage.getItem("reloadPage") === "true") {
        sessionStorage.removeItem("reloadPage");
        getVendorListFromApi();
      }
    }, []);



const  getVendorListFromApi =  async() => {
  purchaseService.getVendorList().then( response => {
  if(response?.data !== undefined){
    setVendorListData(response.data);
    }
    });
  }


  const onActionFilterPerform = (action)=> {
    const option = action.target.value;
    if(Number(option) === 0){
        return setTableData(getVendorListData['Purchase_Order_Info']);
    }
    var newList = getVendorListData['Purchase_Order_Info'].filter((item)=> item.Purchase_Order_Status_Id === Number(option) );
    setTableData(newList);
  }

  

  function selectedTableItems(itemList) {
    setItemSelected(itemList);
  }



  function addNewInvoice(){
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
  }




  async function bulkActions(action) {
    await myPromiseModal({ title: 'confirm your action!',
      body: `Do you want to ${action.Action_Name} ?`,showInput:false, placeHolder:''
    }).then((result) => {
     
      if(result.decision === true){
        let temp = '';
        const option = action.Procedure_Option;
        itemSelected.map(item => {
          temp += `<a> <refno> ${item.Purchase_Order_Ref_No} </refno> </a>`
        });
  
        let xml_string_refno = `<root> ${temp} </root>`;
      //   accountService.setPurchaseBulkAction({xml_string_refno, option}).then(res => {
      //     if(res?.data !== undefined){
      //       const {message_text} = res.data[0];
      //       logicContext.showToast(message_text, 'success');
      //      return  getPurchaseOrderListApi();
      //     }
      // }).catch((err)=> {
      //   logicContext.showToast('Error', 'error');
      // });
      }

    });
  }

  function OnItemCellClick(vendor){
    const id = vendor['Vendor_Id'];
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`)
  }


  const handleSearch = text => {
    setSearchText(text);

    if (text.trim() === '') {
      setTableData(getVendorListData['Vendor_Info'] || []);
      return;
    }

    const searchTerm = text.toLowerCase();
    const filtered = (getVendorListData['Vendor_Info'] || []).filter(vendor =>
      Object.values(vendor).some(value => value?.toString().toLowerCase().includes(searchTerm))
    );
    setTableData(filtered);
  };



  const onClearInput = () => {
    setSearchText('');
    setTableData(getVendorListData['Vendor_Info'] || []);
  };

  


  return (
    <>
      <section>
        <section className="bg-white  px-2    md:flex justify-between ">
          <div className="flex px-2 mt-1">
            {/* 
    {itemSelected.length > 0  ? 
              (
                <div className="row">
                <div className="col col-md-4">
                  <Dropdown>
                    <Dropdown.Toggle
                      style={{
                        backgroundColor: "#E5E5E5",
                        border: "none",
                        color: "#45444B",
                        fontSize: "12px",
                        height: "45px",
                      }}
                      id="dropdown-basic"
                    >
                      Bulk Actions
                    </Dropdown.Toggle>
      
                    <Dropdown.Menu>
                   {getVendorListData['Bulk_Action']?.map((action, i)=> {
                    return (
                      <Dropdown.Item key={i}  onClick={() => bulkActions(action)}>
                      {action.Action_Name}
                     </Dropdown.Item>
                    )

                   })}
                    </Dropdown.Menu>
                  </Dropdown>
    
               
                </div>
      
              </div>
              ):
            (<ActionPaneComponent bulkActionData={getVendorListData['Filtering_Criteria']}
              onSelectBulkAction={onActionFilterPerform} />) } */}

            <Tooltip title="Reload">
              <RestartAlt className="cursor ml-2 mt-1" onClick={() => getVendorListFromApi()} color="primary" fontSize="large" />
            </Tooltip>
          </div>

          <div className="flex justify-between">
            <button className="  font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8 text-sm">IMPORT</button>
            <div className="btn-group">
              <button
                className=" font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8   text-sm"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                EXPORT
              </button>
            </div>

            <button
              onClick={addNewInvoice}
              className="bg-buttonColor font-[Poppins] py-3 mt-1 mr-1 px-3 rounded md:ml-8  text-white text-xs"
            >
              ADD NEW
            </button>
          </div>
        </section>

        {/* Start of search */}
        <div className="flex justify-center mt-4">
          <div className="flex flex-col w-full md:w-1/3">
            <input
              type="text"
              placeholder="Search in Table"
              value={searchText}
              onKeyDown={e => {
                if (e.key === 'Backspace') {
                  onClearInput();
                }
              }}
              onChange={e => handleSearch(e.target.value)}
              className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
            />
          </div>
        </div>
        {/* End of search */}

        <section className="mt-5">
          <GeneralCustomTable
            tableHeadList={columns}
            tableDataList={tableData}
            allowCheckBox={true} // show checkBox for each row
            setSelectedRows={selectedTableItems}
            rowKey={record => record.Vendor_Id} // custom key
            handleRowClick={OnItemCellClick}
          />
        </section>
      </section>
    </>
  );
}

export default VendorPage;
